import "./floatingHelp.css";
import { Dropdown, Tooltip } from "antd";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

// Article titles for the menu - keep in step with wfc-server's seedHelpArticles.ts
const HELP_TITLES = {
    "setup-company-structure": "How your company is organised",
    "setup-users-roles": "Users, roles and data access",
    "setup-employees": "Setting up an employee",
    "setup-sites": "Setting up a site",
    "setup-customer-portal": "Customer portal access",
    "setup-supplier-app": "Supplier app access",
    "ops-adding-duties": "Adding duties (shifts)",
    "ops-rotas": "Rotas: creating, loading and rolling",
    "ops-duty-statuses": "Duty statuses, publishing and bulk actions",
    "ops-clock-in-timeline": "Clocking in, calls and the Timeline",
    "ops-mobile-services": "Mobile services",
    "finance-calculating-pay-bill": "Calculating pay & bill",
    "finance-invoicing": "Creating invoices",
    "finance-currencies": "Currencies",
    "data-views-filters": "Lists, views and filters",
    "data-import-employees": "Importing employees",
    "data-archive-delete": "Archiving and permanent delete",
};

// A round "?" floating in the page's bottom-right corner, for main pages where an inline HelpLink
// would break up the title. slugs: the articles to list (see HELP_TITLES). Each opens in a new
// tab, like HelpLink.
export const FloatingHelp = ({ slugs }) => {
    // Settings opens over the page (any #/setting... hash, as the navbar decides) and has its own
    // Help links - the page's button would float on top of it
    const { hash } = useLocation();
    if (hash.includes("setting")) return null;
    const articles = [...new Set(slugs)].filter((slug) => HELP_TITLES[slug]).map((slug) => ({ slug, title: HELP_TITLES[slug] }));
    return (
    <Dropdown
        trigger={["click"]}
        placement="topRight"
        dropdownRender={() => (
            <div className="floating-help-menu">
                <div className="floating-help-title">Help for this page</div>
                {articles.map((a) => (
                    <a key={a.slug} href={`/user/help/${a.slug}`} target="_blank" rel="noopener noreferrer" className="floating-help-item">
                        <FontAwesomeIcon icon={faCircleQuestion} style={{ color: "#0091ae", marginRight: 8 }} />{a.title}
                    </a>
                ))}
                <a href="/user/help" target="_blank" rel="noopener noreferrer" className="floating-help-all">All help articles</a>
            </div>
        )}
    >
        <Tooltip title="Help" placement="left">
            <button type="button" className="floating-help-button" aria-label="Help">
                <FontAwesomeIcon icon={faCircleQuestion} />
            </button>
        </Tooltip>
    </Dropdown>
    );
};
